"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getClauseIdsForSectionType_1 = require("./getClauseIdsForSectionType");
var store_1 = require("../../store/store");
function getExistingClauseTypesInSection(sectionType) {
    var existingClauseTypesMap = new Map();
    var clauseIds = getClauseIdsForSectionType_1.default(sectionType);
    for (var _i = 0, clauseIds_1 = clauseIds; _i < clauseIds_1.length; _i++) {
        var clauseId = clauseIds_1[_i];
        var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        existingClauseTypesMap.set(clause.clauseType, clauseId);
    }
    return existingClauseTypesMap;
}
exports.default = getExistingClauseTypesInSection;
//# sourceMappingURL=getExistingClauseTypesInSection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getExistingClauseTypesInSection.js
// module id = 3077
// module chunks = 2 90